/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './addMembers.defs'
export { main as default } from './addMembers.defs'
